// Fallback lists in case API fails
export const MC_RELEASES = [
  '26.2', '26.1.2', '26.1.1', '26.1', '26.0',
  '1.21.4', '1.21.3', '1.21.2', '1.21.1', '1.21',
  '1.20.6', '1.20.5', '1.20.4', '1.20.3', '1.20.2', '1.20.1', '1.20',
  '1.19.4', '1.19.3', '1.19.2', '1.19.1', '1.19',
  '1.18.2', '1.18.1', '1.18',
  '1.17.1', '1.17',
  '1.16.5', '1.16.4', '1.16.3', '1.16.2', '1.16.1', '1.16',
  '1.15.2', '1.15.1', '1.15',
  '1.14.4', '1.14.3', '1.14.2', '1.14.1', '1.14',
  '1.13.2', '1.13.1', '1.13',
  '1.12.2', '1.12.1', '1.12',
  '1.11.2', '1.11.1', '1.11',
  '1.10.2', '1.10',
  '1.9.4', '1.9.2', '1.9',
  '1.8.9', '1.8.8', '1.8',
  '1.7.10', '1.7.2'
];

export const MC_SNAPSHOTS = [
  '26.3-snapshot-8', '26.3-snapshot-7', '26.3-snapshot-6', '26.3-snapshot-5', '26.3-snapshot-4',
  '24w14a', '24w13a', '24w12a', '24w11a', '24w10a',
  '24w09a', '24w07a', '24w06a', '24w05a', '24w04a',
  '23w51b', '23w51a', '23w46a', '23w45a', '23w44a'
];

export const LOADERS = [
  { value: 'fabric', label: 'Fabric' },
  { value: 'forge', label: 'Forge' },
  { value: 'neoforge', label: 'NeoForge' },
  { value: 'quilt', label: 'Quilt' },
];